// removed by extract-text-webpack-plugin
module.exports = {"icon":"_4I6O0umF-a9o0SBdUb49X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/agendaListTitle/styles.css
// module id = 1105
// module chunks = 0